import React from 'react';
import useStyles from './css';

const FixedBackground = () => {
  const classes = useStyles();
  return <div className={classes.fixedBackground} />;
};

export default FixedBackground;
